export default "__VITE_ASSET__6afa548a__"